import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useLanguage from "../redux/use-language.js";

export function SearchBox() {
  const [search, setSearch] = useState("");
  const { language } = useLanguage();
  const navigate = useNavigate();
  const lang = language || "en";
  const trimmed = search.trim();
  const searchUrl = trimmed ? `/${lang}/search/${encodeURIComponent(trimmed)}` : null;

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (trimmed) navigate(`/${lang}/search/${encodeURIComponent(trimmed)}`);
  };

  return (
    <form onSubmit={handleSubmit} className="searchBox flex">
      <input
        type="text"
        className="search-input flex-grow min-w-0"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder={lang === "ru" ? "Поиск…" : "Search…"}
        aria-label={lang === "ru" ? "Поиск" : "Search"}
      />
      {searchUrl ? (
        <Link to={searchUrl}>
          <button type="button" className="searchButton" aria-label={lang === "ru" ? "Искать" : "Search"}>
            &#x1F50D;
          </button>
        </Link>
      ) : (
        <button type="submit" className="searchButton" aria-label={lang === "ru" ? "Искать" : "Search"} disabled>
          &#x1F50D;
        </button>
      )}
    </form>
  );
}
